export default {
 urlToApi: '/api/',
  urlToServer: '/'
 }
